import { computed } from "vue";
import redirect from "@dpa-connect/dpa-id-user/store/utils/redirect";
import windowHelper from "@dpa-connect/dpa-id-user/store/utils/window";
import store from "@/store";

const ls = windowHelper().localStorage;

export default () => {
  /* Computed props */
  const ssoURLAuth0 = computed(
    () =>
      // eslint-disable-next-line prettier/prettier
    store.state.stageconfig?.config?.ssoURLAuth0 || ""
  );

  const dpaIdURL = computed(
    () => store.state.stageconfig?.config?.dpaIdURL || ""
  );

  const stageConfig = computed(() => store.state.stageconfig?.config);

  const isAuthenticated = computed(() => store.getters["auth/isAuthenticated"]);

  const authIsLoading = computed(() => store.state.auth?.isLoading === true);

  const status = computed(() => String(store.state.auth?.status));

  const token = computed(() =>
    store.getters["auth/validateAndRetrieveToken"]()
  );

  const clearToken = (appName = "select") => {
    // NB: Remove "stale" JWT token from session storage
    const sessionAuthJWT = ls.getItem(
      `dpaID-token${appName ? `-${appName}` : ""}`
    );
    if (sessionAuthJWT) {
      ls.removeItem(`dpaID-token${appName ? `-${appName}` : ""}`);
    }

    // Loutout unless on the unauthorized page
    if (
      ssoURLAuth0.value &&
      !window.location.pathname.match(/\/unauthorized/)
    ) {
      const { auth0ClientId } = store.state.stageconfig.config;
      const authPath = status.value === "loggedout" ? "/login" : "/logout";
      const originUrl = window.location.origin;

      redirect(
        `${ssoURLAuth0.value}${authPath}?returnTo=${encodeURIComponent(
          originUrl
        )}&client_id=${auth0ClientId}`
      );
    }
  };

  const validateAndRetrieveToken = () => {
    const jwt = store.getters["auth/validateAndRetrieveToken"]();

    if (!jwt && !!store.state.auth.token) {
      return clearToken();
    }

    return jwt;
  };

  const profile = computed(() => store.state.user?.profile);

  /* Methods */
  // eslint-disable-next-line no-shadow
  const authenticate = ({ token, cert }) =>
    store.dispatch("auth/authenticate", { token, cert });

  const logout = () => store.dispatch("auth/logout");

  return {
    ssoURLAuth0,
    dpaIdURL,
    stageConfig,
    isAuthenticated,
    authIsLoading,
    token,
    profile,
    authenticate,
    logout,
    status,
    validateAndRetrieveToken,
    clearToken
  };
};
